import React from 'react'
import { useTheme, CircularProgress } from '@mui/material'
import { Icon, PlayCircle } from 'iconsax-react'

import useStyles from './styles'

type LoadingIndicatorProps = {
  loading: boolean
  onClick: () => void
  Icon?: Icon
}

const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({
  loading,
  onClick,
  Icon = PlayCircle
}) => {
  const theme = useTheme()

  const classes = useStyles()

  return (
    <div className={classes.root}>
      {loading ? (
        <CircularProgress />
      ) : (
        <Icon
          onClick={onClick}
          size={theme.size.xxxl}
          variant='Bold'
          color={theme.palette.primary.main}
          className={classes.icon}
        />
      )}
    </div>
  )
}

export default LoadingIndicator
